(function () {
  function initHeader() {
    var h = document.getElementById('hd');
    if (!h) return;
    var update = function () { h.classList.toggle('s', window.scrollY > 70); };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function initProductForm() {
    var select = document.getElementById('SuustonVariant');
    var price = document.getElementById('SuustonPrice');
    var button = document.getElementById('SuustonAddButton');
    if (!select || !price || !button) return;

    function updateVariant() {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      if (option.dataset.price) price.textContent = option.dataset.price;
      var available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? 'Try it for 14 nights' : 'Sold out';
    }

    select.addEventListener('change', updateVariant);
    updateVariant();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initHeader();
      initProductForm();
    });
  } else {
    initHeader();
    initProductForm();
  }
})();
